// extracted by mini-css-extract-plugin
export default {"ligIconContainer":"style_ligIconContainer__afizK"};